import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, makeStyles } from "@fluentui/react-components";
import { DeleteRegular, EditRegular } from "@fluentui/react-icons";

import { IMenuItemDb } from "@dining/api-client";
import { ModalType } from "../../common/commonConstants";
import { setModal, toggleAddItemPanel } from "../../reducers/diningReducer";
import { selectedItemSelector } from "../../selectors/diningSelector";
import { useRestoreFocusOnDialogClose } from "../DialogBox";

const useStyles = makeStyles({
  container: {
    display: "flex",
    gap: "4px",
    alignItems: "center",
  },
  editButton: {
    backgroundColor: "transparent !important",
    ":hover": {
      backgroundColor: "transparent !important",
    },
    ":active": {
      backgroundColor: "transparent !important",
    },
  },
  deleteButton: {
    color: "red",
    backgroundColor: "transparent !important",
    ":hover": {
      backgroundColor: "transparent !important",
      color: "red",
    },
    ":active": {
      backgroundColor: "transparent !important",
    },
  },
});

export const EditDeleteColumn = (props: { selectedGridDataGUID: string }) => {
  const selectedMenuItem: IMenuItemDb | undefined = useSelector(selectedItemSelector);
  const editButtonRef = React.useRef<HTMLButtonElement | null>(null);
  const deleteButtonRef = React.useRef<HTMLButtonElement | null>(null);
  const captureTrigger = useRestoreFocusOnDialogClose(ModalType.CONFIRM_MENU_ITEM_DELETE);

  const dispatch = useDispatch();
  const styles = useStyles();

  const handleDelete = () => {
    captureTrigger();
    dispatch(setModal(ModalType.CONFIRM_MENU_ITEM_DELETE));
  };

  const handleEdit = () => {
    dispatch(toggleAddItemPanel());
  };

  if (selectedMenuItem?.id !== props.selectedGridDataGUID) {
    return null;
  }
  return (
    <div className={styles.container} role="toolbar" aria-label="Menu item actions">
      <Button
        ref={editButtonRef}
        appearance="subtle"
        title="Edit"
        className={styles.editButton}
        icon={<EditRegular style={{ color: "#0078d4", backgroundColor: "transparent" }} />}
        aria-label="Edit"
        onClick={handleEdit}
      />

      <Button
        ref={deleteButtonRef}
        appearance="subtle"
        icon={<DeleteRegular style={{ color: "red", backgroundColor: "transparent" }} />}
        aria-label="Delete"
        onClick={handleDelete}
        title="Delete"
        className={styles.deleteButton}
      />
    </div>
  );
};
